import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { unref } from 'vue';
import { getApi } from './api';

export default (accountId: Ref<number> | number) => {
  return useQuery({
    queryKey: ['account-shipment-metrics', () => unref(accountId)],
    queryFn: () => {
      const { api, baseURL } = getApi();
      const actualAccountId = unref(accountId);
      return api
        .get(`/api/accounts/${actualAccountId}/shipments/metrics`, { baseURL })
        .then((res: { data: { data?: Record<string, unknown> } }) => {
          const body = res.data;
          return (body?.data ?? body) as Record<string, unknown>;
        });
    },
    enabled: !!unref(accountId),
  });
};
